import { formatDistanceToNow } from "date-fns";
import { useEffect, useRef, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { API_URL } from "../../environment";
import images from "../../assets/img/avatar-3.png"
import axios from "axios";
const Chatbot = () => {
    const [modal, setModal] = useState(false);
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [image, setImage] = useState("");
    const lastMessageRef = useRef(null);
    const userid = localStorage.getItem("USERID");

    useEffect(() => {
// getLoginUserDetail()
if (modal) {
setTimeout(() => {
    const dummyQuestions = [
        { sender: "bot", text: "Hi! How can I help you today?", id: Date.now() },
        { sender: "bot", text: "Do you want to know about our company?", id: Date.now() + 1 },
        { sender: "bot", text: "Would you like to speak with a HR?", id: Date.now() + 2 },
    ];
    setMessages(dummyQuestions);
    
}, 200);
}

    }, [modal]);
  

    useEffect(() => {
        lastMessageRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const handleMessageSubmit = async (e) => {
        e.preventDefault();

        // add message to the chat
        const userMessage = { sender: "user", text: input, id: Date.now() };

        setMessages((prevMessages) => [...prevMessages, userMessage]);



        try {
            console.log('hello');
            
            const OPENAI_API_KEY = "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";
            const apiUrl = 'https://api.openai.com/v1/chat/completions';
            
            const header = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${OPENAI_API_KEY}`,
            };
        
            // Assuming 'input' is defined elsewhere in your code
            const input = "Your input message here"; // Replace this with the actual input
            
            const payload = {
                messages: [
                    { role: "system", content: "You are a helpful assistant." },
                    { role: "user", content: input },
                ],
                max_tokens: 800,
                temperature: 1,
                model: 'gpt-3.5-turbo',
            };
        
            const response = await axios.post(apiUrl, payload, { headers: header });
        
            // Axios automatically parses JSON, so you can directly access the response data
            console.log('response', response.data);
        
            const aiMessage = {
                sender: "bot",
                text: response.data.choices[0].message.content.trim(),
                id: Date.now() + 1,
            };
        
            // Assuming you have a setMessages function to update state (like React state)
            setMessages((prevMessages) => [...prevMessages, aiMessage]);
        
        } catch (error) {
            console.error('Error making API request:', error);
                        console.error("Error fetching AI response:", error);
            setMessages((prevMessages) => [
                ...prevMessages,
                { sender: "bot", text: "Sorry, there was an error getting a response.", id: Date.now() + 2 },
            ]);
        }









       
    //         const OPENAI_API_KEY = "sk-abcdefabcdefabcdefabcdefabcdefabcdef12";
    //         const response = await fetch("https://api.openai.com/v1/chat/completions", {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //               'Authorization':  `Bearer ${OPENAI_API_KEY}`,
    // },
    //             body: JSON.stringify({
    //                 model: "gpt-4",
    //                 messages: [
    //                     { role: "system", content: "You are a helpful assistant." },
    //                     { role: "user", content: input },
    //                 ],
    //                 max_tokens: 100,
    //                 temperature: 0.7,
    //             }),
    //         });
    
    //         const data = await response.json();
    //         const aiMessage = {
    //             sender: "bot",
    //             text: data.choices[0].message.content.trim(),
    //             id: Date.now() + 1,
    //         };
    
        //     setMessages((prevMessages) => [...prevMessages, aiMessage]);
        // } 
        
        
        
        // catch (error) {
        //     console.error("Error fetching AI response:", error);
        //     setMessages((prevMessages) => [
        //         ...prevMessages,
        //         { sender: "bot", text: "Sorry, there was an error getting a response.", id: Date.now() + 2 },
        //     ]);
        // }

        // const dummyQuestions = [
        //     { sender: "bot", text: "Hi! How can I help you today?", id: Date.now() + 1 },
        //     { sender: "bot", text: "Do you want to know about our services?", id: Date.now() + 2 },
        //     { sender: "bot", text: "Would you like to speak with a representative?", id: Date.now() + 3 },
        // ];

        // setTimeout(() => {
        //     setMessages((prevMessages) => [...prevMessages, ...dummyQuestions]);
        // }, 1000);
       
    

        // Send message to the server
        // socket.emit("chat message", {
        //     sender: "user",
        //     text: input,
        //     id: userMessage.id,
        // });

        setInput("");
    };

    const toggleModal = () => {
        setModal((prev) => !prev);
    };

    return (
        <>
            <button
                type="button"
                class="btn btn-primary chat-btn"
                data-bs-target="#exampleModal"
                onClick={toggleModal}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 54 54"
                    fill="none"
                >
                    <path
                        d="M3.46781 28.7571C1.38902 29.351 0 31.2247 0 33.3281V39.6562C0 41.8236 1.46074 43.6567 3.44988 44.222C3.3307 43.4552 3.26953 42.6705 3.26953 41.8711C3.26953 30.2891 3.26099 30.9919 3.29063 30.4203C3.3191 29.8571 3.37922 29.3024 3.46781 28.7571Z"
                        fill="#FF8E27"
                    />
                    <path
                        d="M50.5312 28.7571C50.6631 29.566 50.7306 30.3887 50.7306 31.2187V41.8711C50.7306 42.6705 50.6694 43.4552 50.5502 44.222C52.5394 43.6567 54.0001 41.8236 54.0001 39.6562V33.3281C54.0001 31.1544 52.5299 29.3161 50.5312 28.7571Z"
                        fill="#FF8E27"
                    />
                    <path
                        d="M47.1445 28.582H29.7021L24.3759 31.2451C23.721 31.5731 22.9869 31.7461 22.2539 31.7461C21.3722 31.7461 20.5084 31.5014 19.7585 31.0373C18.3495 30.1662 17.5078 28.6569 17.5078 27V19.1362C11.3115 19.672 6.43359 24.8864 6.43359 31.2187V41.8711C6.43359 48.5588 11.8747 54 18.5625 54H35.4375C42.1253 54 47.5664 48.5588 47.5664 41.8711V31.2187C47.5664 30.3244 47.4683 29.4395 47.2764 28.5799C47.2321 28.582 47.1888 28.582 47.1445 28.582ZM20.6719 36.4922C20.6719 37.3659 19.9635 38.0742 19.0898 38.0742C18.2161 38.0742 17.5078 37.3659 17.5078 36.4922V33.3281C17.5078 32.4544 18.2161 31.7461 19.0898 31.7461C19.9635 31.7461 20.6719 32.4544 20.6719 33.3281V36.4922ZM30.1641 44.4023H23.8359C22.9622 44.4023 22.2539 43.694 22.2539 42.8203C22.2539 41.9466 22.9622 41.2383 23.8359 41.2383H30.1641C31.0378 41.2383 31.7461 41.9466 31.7461 42.8203C31.7461 43.694 31.0378 44.4023 30.1641 44.4023ZM36.4922 36.4922C36.4922 37.3659 35.7839 38.0742 34.9102 38.0742C34.0365 38.0742 33.3281 37.3659 33.3281 36.4922V33.3281C33.3281 32.4544 34.0365 31.7461 34.9102 31.7461C35.7839 31.7461 36.4922 32.4544 36.4922 33.3281V36.4922Z"
                        fill="#FF8E27"
                    />
                    <path
                        d="M6.43359 18.8177C8.27508 18.1649 9.59766 16.4057 9.59766 14.3438C9.59766 11.7271 7.46824 9.59766 4.85156 9.59766C2.23488 9.59766 0.105469 11.7271 0.105469 14.3438C0.105469 16.4057 1.42805 18.1649 3.26953 18.8177C3.26953 21.7287 3.26953 23.9003 3.26848 25.5234L4.51828 25.1659C5.01293 24.0247 5.65207 22.931 6.43359 21.9143V18.8177Z"
                        fill="#FF8E27"
                    />
                    <path
                        d="M47.1445 0H27.5273C23.7472 0 20.6719 3.07536 20.6719 6.85547V27C20.6719 27.5482 20.9558 28.0574 21.4222 28.3458C21.6763 28.5028 21.9647 28.582 22.254 28.582C22.4957 28.582 22.7382 28.5267 22.9615 28.415L28.9555 25.418H47.1445C50.9246 25.418 54 22.3426 54 18.5625V6.85547C54 3.07536 50.9246 0 47.1445 0ZM45.9844 17.5078H28.6875C27.8138 17.5078 27.1055 16.7995 27.1055 15.9258C27.1055 15.0521 27.8138 14.3438 28.6875 14.3438H45.9844C46.8581 14.3438 47.5664 15.0521 47.5664 15.9258C47.5664 16.7995 46.8581 17.5078 45.9844 17.5078ZM45.9844 11.1797H28.6875C27.8138 11.1797 27.1055 10.4714 27.1055 9.59766C27.1055 8.72395 27.8138 8.01562 28.6875 8.01562H45.9844C46.8581 8.01562 47.5664 8.72395 47.5664 9.59766C47.5664 10.4714 46.8581 11.1797 45.9844 11.1797Z"
                        fill="#FF8E27"
                    />
                </svg>
            </button>

        

            {modal && (
                <div
                    class="chat-modal-container"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div class="modal-dialog">
                        <div class="modal-content chat-bot-dialog p-0">
                            <div class="modal-header d-flex justify-content-end chat-bot-header align-items-center">
                                <button
                                    type="button"
                                    className="chat-close-btn"
                                    aria-label="Close"
                                    onClick={() => setModal(false)}
                                >
                                    <img
                                        src="assets/img/close-btn.png"
                                        width={"100%"}
                                        alt=""
                                    ></img>
                                </button>
                            </div>
                            <div class="modal-body chat-bot-body p-3">
                              
                                {messages.map((message, index) => (
                                    <div
                                        key={index}
                                        className={`mt-3 mb-0 d-flex align-items-end
                                     ${message.sender === "user"
                                                ? "justify-content-end"
                                                : "align-items-end"
                                            } `}
                                    >
                                        <div
                                            className={`d-flex flex-column
                                            ${message.sender === "user"
                                                    ? "align-items-end me-2"
                                                    : "ms-2"
                                                } `}
                                        >
                                            <div
                                                className={`chat-user-${message.sender === "user" ? "2" : "1"
                                                    }`}
                                            >
                                                <span>{message.text}</span>
                                            </div>
                                            <span className="time-span">
                                                {formatDistanceToNow(new Date(message.id))} ago
                                            </span>
                                        </div>
                                      {/* {message.sender === "user" ?<>
                                        <img
                                            className={message.sender === "user" ? "mb-4" : "mt-3"}
                                            // API_URL+image
                                            src={
                                                message.sender === "user"
                                                    ?images
                                                    : images
                                            }
                                            height={"35px"}
                                            width={"35px"}
                                            alt=""
                                        ></img></>:''

                                      }  */}
                                    
                                        <div ref={lastMessageRef} />
                                    </div>
                                ))}
                            </div>



                            <div class="modal-footer justify-content-start p-2">
                                <form className="w-100" onSubmit={handleMessageSubmit}>
                                    <div className="msg-wrapper">
                                        <input
                                            type="text"
                                            className="msg-input w-100"
                                            placeholder="Type message here..."
                                            value={input}
                                            onChange={(e) => setInput(e.target.value)}
                                        ></input>
                                    
                                        <button
                                            type="submit"
                                            className="msg-btn"
                                            disabled={input.trim() === ""}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="28"
                                                height="28"
                                                viewBox="0 0 27 28"
                                                fill="none"
                                            >
                                                <path
                                                    d="M26 1.5L12.25 15.25"
                                                    stroke="#F2F2F2"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M26 1.5L17.25 26.5L12.25 15.25L1 10.25L26 1.5Z"
                                                    stroke="#F2F2F2"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </form>
                            </div>


                            
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Chatbot;
